/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {ScheduleItem} from "./ScheduleItem";
import {AgeCategory} from "./metadata/AgeCategory";
import {EntryCategory} from "./metadata/EntryCategory";
import {EntryClassification} from "./metadata/EntryClassification";
import {EntryType} from "./metadata/EntryType";
import {Studio} from "../Studio";
import {List} from "ionic-angular";
import {CompetitionMetadata} from "./metadata/CompetitionMetadata";
/**
 * Created by andrea on 2017-06-24.
 */

export class EntryScheduleItem extends ScheduleItem {

  private _ageCategory: AgeCategory;
  private _category: EntryCategory;
  private _classification: EntryClassification;
  private _entryType: EntryType;
  private _descriptionOverride: string;

  public get ageCategory(): AgeCategory {
    return this._ageCategory;
  }

  public set ageCategory(ageCategory: AgeCategory) {
    this._ageCategory = ageCategory;
    this.updateDescription();
  };


  get category(): EntryCategory {
    return this._category;
  }

  set category(value: EntryCategory) {
    this._category = value;
    this.updateDescription();
  }

  get classification(): EntryClassification {
    return this._classification;
  }

  set classification(value: EntryClassification) {
    this._classification = value;
    this.updateDescription();
  }

  get entryType(): EntryType {
    return this._entryType;
  }

  set entryType(value: EntryType) {
    this._entryType = value;
    this.updateDescription();
  }

  public studio: Studio;
  public dancerList: string[] = [];
  // public isDancerFollowed = false;
  // public idStudioFollowed = false;

  private updateDescription() {
    if (this._descriptionOverride) {
      this.description = this._descriptionOverride;
    } else {

      let age = this._ageCategory ? this._ageCategory.name : '';
      let category = this._category ? this._category.name : '';
      let classification = this._classification ? this._classification.name : '';
      let entryType = this._entryType ? this._entryType.name : '';

      this.description = `${classification} ~ ${age} ~ ${category} ~ ${entryType}`;
    }
  }

  constructor(public id: string,
              public timestamp: number,
              public entryNumber: string,
              public routineType: number,
              public entryStatus: number,
              public date: string,
              public timeSlot: string,
              public duration: number,
              public sequence: number,
              public title: string,
              public description: string,
              public fixedType: number,
              public numberDancers: number,
              public dancers: string) {

    super(id, timestamp, routineType, entryStatus, date, timeSlot, duration, sequence, title, description, fixedType);

    if (dancers) {
      this.dancerList = dancers.split(',').map(dancer => dancer.trim());
      this.numberDancers = this.dancerList.length;
    }
  }

  static fromJson(key: string, json: any) {
    return EntryScheduleItem._fromSnapshot(key, json);
  }

  static fromSnapshot(snapshot: any) {
    return EntryScheduleItem._fromSnapshot(snapshot.key, snapshot.val());
  }

  private static _fromSnapshot(key: string,
                               {ageCategory, category, classification, dancers, date, description, duration,
                                 entryNumber, fixedType, entryStatus, entryType, numberDancers, routineType, sequence,
                                 studio, timestamp, title, timeSlot}) {

    let entryItem: EntryScheduleItem = new EntryScheduleItem(key, timestamp, entryNumber, routineType, entryStatus,
      date, timeSlot, duration, sequence, title, null, fixedType, numberDancers, dancers);

    entryItem.ageCategory = new AgeCategory(ageCategory, null, null, null, null);
    entryItem.category = new EntryCategory(category, null, null);
    entryItem.classification = new EntryClassification(classification, null, null);
    entryItem.entryType = new EntryType(entryType, null, null, null, null);
    entryItem.studio = Studio.fromEntryJson(studio);
    entryItem._descriptionOverride = description;

    return entryItem;
  }

}



// WEBPACK FOOTER //
// ./src/models/schedule/EntryScheduleItem.ts